import React from 'react'

import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'

import { useConsentConfig } from 'components/ConsentConfigProvider'
import { useLocation } from 'components/LocationProvider'

import TextLink from '../TextLink'

import Locale from './locale'


export default function ImpressumLink({ style }) {
  const consentConfig = useConsentConfig()
  const impressumURL = consentConfig.policy_settings?.impressum_url
  const { countryCode } = useLocation()

  if ( countryCode !== 'DE' || !impressumURL ) {
    return null
  }

  const values = {
    link: renderLink({ impressumURL, style }),
  }

  return (
    <FormattedMessage
      { ...Locale.notice }
      values={ values }
    />
  )
}

ImpressumLink.propTypes = {
  style: PropTypes.object,
}

function renderLink({ impressumURL, style }) {
  return (chunks) => (
    <TextLink
      href={ impressumURL }
      rel="noreferrer"
      style={ style }
      target="_blank"
    >
      { chunks }
    </TextLink>
  )
}
